import axiosInstance from "../../utils/axiosConfig";
import React, { useEffect, useState } from "react";
import { TailSpin } from "react-loader-spinner";
import { noTransaction } from "../../assets/images";
import { API_URL } from "../../constant";
import { useAuth } from "../../context/auth-context";
import { formatAmount } from "../../utils/FormatPerson";
import toast from "react-hot-toast";
import { BsArrowLeftSquare, BsArrowRightSquare } from "react-icons/bs";
import RewardModal from "./RewardModal";

const Rewards = () => {
  const { query, isAuthenticated } = useAuth();

  const [loading, setLoading] = useState<boolean>(false);
  const [rewards, setRewards] = useState<any[]>([]);
  const [refetchCount, setRefetchCount] = useState<number>(0);
  const [page, setPage] = useState<number>(1);
  const [showRewardModal, setRewardModal] = useState<boolean>(false);
  const [selectedReward, setSelectedReward] = useState<any>(null);

  const [currentpage, setCurrentPage] = useState<number>();
  const [totalPages, setTotalPages] = useState<number>(1);

  const [approveLoading, setApproveLoading] = useState<boolean>(false);
  const approveReward = (id: string, status: string) => {
    if (!approveLoading) {
      setApproveLoading(true);

      axiosInstance
        .post(`${API_URL}api/tasks/points-claim-requests/${id}`, {
          action: `${status}`,
        })
        .then((r: any) => {
          //   console.log(r.data.data);
          toast.success(`You have successfully ${status} reward`);
          setTimeout(() => {
            setRefetchCount((prev: number) => prev + 1);
          }, 1200);
          setApproveLoading(false);
        })
        .catch((e: any) => {
          setApproveLoading(false);
          console.log(e.response.data.message);
          toast.error(e.response.data.message, { duration: 4000 });
        });
    }
  };

  useEffect(() => {
    setLoading(true);
    axiosInstance
      .get(`${API_URL}api/tasks/points-claim-requests?page=${page}`)
      .then((r: any) => {
        const rewardLists = r.data.data?.claimRequests;

        //  console.log(r.data.data);
        setRewards(rewardLists);
        setCurrentPage(r.data.data?.meta?.currentPage);
        setTotalPages(r.data.data?.meta?.totalPages);
        setLoading(false);
      })
      .catch((e: any) => {
        console.log(e.response.data.message);

        setLoading(false);
      });
  }, [isAuthenticated, refetchCount, page]);
  return (
    <div className="w-full  h-full">
      <div className="bg-[#0D0D0D] overflow-auto scrollbar-thumb-[#60B7F6] scrollbar-track-white mb-8  scrollbar-thin w-full h-[512px] ">
        <table className="w-full">
          <thead>
            <tr className="h-[56px] bg-[#1C2227] flex justify-start px-6 items-center sticky top-0">
              <th className="text-[#617889] text-[15px] overflow-hidden w-1/5  mr-4 text-left whitespace-nowrap">
                Date
              </th>
              <th className="text-[#617889] text-[15px] overflow-hidden w-1/5  mr-4 text-left whitespace-nowrap">
                Customer ID
              </th>

              <th className="text-[#617889] text-[15px] overflow-hidden w-1/5  text-left whitespace-nowrap">
                Points
              </th>
              <th className="text-[#617889] text-[15px] overflow-hidden w-1/5  text-left whitespace-nowrap">
                Amount (NGN)
              </th>
              <th className="text-[#617889] text-[15px] overflow-hidden w-1/5  mr-4 text-left whitespace-nowrap">
                Status
              </th>
              <th className="text-[#617889] text-[15px] overflow-hidden w-1/5 text-left whitespace-nowrap">
                Action
              </th>
            </tr>
          </thead>
          {loading ? (
            <div className="mt-12 w-full   flex justify-center items-start">
              <TailSpin color="#0B75C2" height={70} width={90} />
            </div>
          ) : (
            <div className="w-full">
              {rewards.length >= 1 ? (
                <table className="w-full">
                  {rewards
                    .filter((searchValue) => {
                      return query.toLowerCase() === ""
                        ? searchValue
                        : searchValue.task.name.toLowerCase().includes(query) ||
                            searchValue.user.profile.firstName
                              .toLowerCase()
                              .includes(query) ||
                            searchValue.user.profile.lastName
                              .toLowerCase()
                              .includes(query);
                    })
                    .map((reward, index) => (
                      <tbody key={index} className="w-full">
                        <tr
                          className="h-[56px] flex justify-start px-6 items-center w-full cursor-pointer hover:bg-[#1C2227]"
                          onClick={() => {
                            setSelectedReward(reward);
                            setRewardModal(true);
                          }}
                        >
                          <td className="text-white text-[15px] w-1/5 mr-4 overflow-hidden whitespace-nowrap ">
                            {(() => {
                              const dateString = reward.updatedAt;
                              const date = new Date(dateString);

                              const day = date.getDate();
                              const ordinalSuffix = (day: number) => {
                                switch (day) {
                                  case 1:
                                  case 21:
                                  case 31:
                                    return "st";
                                  case 2:
                                  case 22:
                                    return "nd";
                                  case 3:
                                  case 23:
                                    return "rd";
                                  default:
                                    return "th";
                                }
                              };

                              const formattedDate = `${date.toLocaleString(
                                "default",
                                {
                                  month: "short",
                                }
                              )} ${day}${ordinalSuffix(
                                day
                              )}, ${date.getFullYear()}, ${date.toLocaleString(
                                "default",
                                {
                                  hour: "numeric",
                                  minute: "numeric",
                                  hour12: true,
                                }
                              )}`;

                              return formattedDate;
                            })()}
                          </td>
                          <td className="text-white text-[15px] w-1/5 mr-4 overflow-hidden whitespace-nowrap">
                            {reward?.userId}
                          </td>
                          <td className="text-white text-[15px] w-1/5  overflow-hidden whitespace-nowrap">
                            {formatAmount(reward?.points)}
                          </td>
                          <td className="text-white text-[15px] w-1/5  overflow-hidden whitespace-nowrap">
                            {formatAmount(reward?.cashAmount)}
                          </td>

                          <td className="text-white text-[15px] w-1/5 overflow-hidden flex justify-start mr-4 items-center whitespace-nowrap ">
                            <h4
                              className={
                                reward?.status?.toUpperCase() === "PENDING"
                                  ? "text-[#CB9200] flex justify-center items-center w-[75%] xl:w-2/5 bg-[#181818] tracking-wider h-[26px] rounded-full text-[9px] font-bold"
                                  : reward?.status?.toUpperCase() === "DECLINED"
                                  ? "text-red-500 flex justify-center items-center w-[75%] xl:w-2/5 bg-[#181818] tracking-wider h-[26px] rounded-full text-[9px] font-bold"
                                  : reward?.status?.toUpperCase() === "APPROVED"
                                  ? "text-[#03C668] flex justify-center items-center w-[75%] xl:w-2/5 bg-[#0E2B1F] tracking-wider h-[26px] rounded-full text-[9px] font-bold"
                                  : ""
                              }
                            >
                              {reward?.status}
                            </h4>
                          </td>
                          <td
                            //   onClick={() => applyToTask(task._id, task.task.name)}
                            className="w-1/5   flex justify-start items-center  "
                          >
                            <div className="   ">
                              {reward?.status === "PENDING" ? (
                                <div>
                                  {approveLoading ? (
                                    <TailSpin
                                      color="#FFFFFF"
                                      height={20}
                                      width={20}
                                    />
                                  ) : (
                                    <div className=" flex justify-center gap-3 items-center">
                                      <button
                                        onClick={() =>
                                          approveReward(reward._id, "approve")
                                        }
                                        className="text-[#03C668] font-bold text-[14px]"
                                      >
                                        Approve
                                      </button>
                                      <button
                                        onClick={() =>
                                          approveReward(reward._id, "decline")
                                        }
                                        className="text-[#DF4E4E] font-bold text-[14px]"
                                      >
                                        Decline
                                      </button>
                                    </div>
                                  )}
                                </div>
                              ) : (
                                <span>
                                  <span className="text-[#3A4852] font-bold text-[14px]">
                                    {reward?.status}
                                  </span>
                                </span>
                              )}
                            </div>
                          </td>
                        </tr>
                        <tr className="w-full">
                          <td className="mt-1 w-full h-[1px] bg-[#13181B]" />
                        </tr>
                      </tbody>
                    ))}
                </table>
              ) : (
                <div className="flex flex-col justify-center mt-12 w-full lgss:mt-12 items-center">
                  <img src={noTransaction} alt="" />
                  <h4 className="font-bold text-[#869AA9] pt-2">
                    No rewards at the moment
                  </h4>
                  <p className=" text-[#869AA9] pt-2 text-[12px]">
                    All rewards will show up here
                  </p>
                </div>
              )}
            </div>
          )}
        </table>
      </div>
      {rewards?.length >= 1 ? (
        <div className="flex gap-4 pb-10 justify-end items-center">
          <h4 className="font-bold font-sora text-[14px] text-white">
            Page {currentpage} of {totalPages}
          </h4>
          <button className="flex justify-center items-center">
            <BsArrowLeftSquare
              onClick={() => {
                if (page > 1) {
                  setPage((prev) => prev - 1);
                }
              }}
              className="text-3xl cursor-pointer text-[#C6D0D7] font-bold"
            />
          </button>

          <button>
            <BsArrowRightSquare
              onClick={() => {
                if (page < totalPages) {
                  setPage((prev) => prev + 1);
                }
              }}
              className="text-3xl cursor-pointer text-[#C6D0D7]"
            />
          </button>
        </div>
      ) : null}
      {showRewardModal && (
        <RewardModal setRewardModal={setRewardModal} reward={selectedReward} />
      )}
    </div>
  );
};

export default Rewards;
